import { SearchOutlined } from "@ant-design/icons";
import { Input, Dropdown, MenuProps } from "antd";
import { downloadSVG } from "../../assets/reports/SVGs";
import { useIntl } from "react-intl";
import { saveAs } from "file-saver";

const HeaderTable = ({ data }: any) => {
  const intl = useIntl();
  console.log(data?.data);
  const FormattedList = (data: any) => {
    return data?.map((x: any) => {
      return {
        type: x?.type,
        total_discount: x?.total_discount,
        total: x?.total,
        count: x?.count_products,
        taxes: x?.taxes,
        pay: x?.pay,
      };
    });
  };
  const handleDownload = (type: string) => {
    // This is a placeholder function. Implement actual file generation and download logic here.
    const blob = new Blob(FormattedList(data?.data), {
      type: "text/plain;charset=utf-8",
    });
    saveAs(blob, `download.${type}`);
  };

  const items: MenuProps["items"] = [
    {
      label: intl.formatMessage({
        id: "downloadPDF",
        defaultMessage: "تحميل PDF",
      }),
      key: "1",
      onClick: () => handleDownload("pdf"),
    },
    {
      label: intl.formatMessage({
        id: "downloadCSV",
        defaultMessage: "تحميل CSV",
      }),
      key: "2",
      onClick: () => handleDownload("csv"),
    },
    {
      label: intl.formatMessage({
        id: "downloadXSLX",
        defaultMessage: "تحميل XSLX",
      }),
      key: "3",
      onClick: () => handleDownload("xlsx"),
    },
  ];

  const menuProps = { items };

  return (
    <header className="flex items-center justify-between">
      <div className="flex items-center w-full">
        {/* <Dropdown
          className="bg-white cursor-pointer px-3 py-2 pb-1 rounded-xl border-solid border-[1px] border-[#B0B0C0]"
          menu={menuProps}
        >
          <div>{downloadSVG}</div>
        </Dropdown> */}
      </div>
      <div className="flex items-center w-full gap-5">
        <Input
          size="small"
          placeholder={intl.formatMessage({ id: "reportSearchPlaceholder" })}
          className="w-full rounded-lg h-full p-2"
          suffix={
            <SearchOutlined
              style={{
                color: "#9999A7",
                position: "absolute",
                right: 8,
                top: 12,
              }}
            />
          }
          style={{ paddingRight: 30 }} // Increase paddingRight to accommodate the icon
        />
      </div>
    </header>
  );
};

export default HeaderTable;
